<script lang="ts">
export default {
  name: 'EmptyDisplay',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  src?: string;
  alt?: string;
  title?: string;
  text?: string;
  bordered?: boolean;
  height?: string;
  imgHeight?: string;
}>();

const imgStyle = computed(() => {
  if (props.imgHeight) {
    return { height: props.imgHeight };
  }
  return {};
});
</script>

<template>
  <div class="content" :class="{ bordered }" :style="{ height: height || '60vh' }">
    <img v-if="!!src" :src="src" :alt="alt" :style="imgStyle"/>
    <h2 v-if="!!title">{{ title }}</h2>
    <p v-if="!!text">{{ text }}</p>
    <slot></slot>
  </div>
</template>

<style scoped>
.content {
  display: grid;
  grid-template-columns: 0.4fr;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  height: 60vh;
}

.content.bordered {
  border: 1px solid var(--v-border-base);
}

.content > * {
  text-align: center;
}

h2 {
  margin-top: 1em;
}

img {
  margin: auto;
  width: 100%;
  height: auto;
  max-height: 30vh;
}
</style>
